import styles from './cssModules/index.module.css';
import error from './gallary/error.gif';

export default function Errorpage() {

    return (
        <>
            <div className={`${styles.errorDiv}`}>
                <img src={error} alt='Error' className={`${styles.errorIcon}`}/>
            </div>
        </>
    )
}